import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminCompanies from './AdminCompanies';

export default withRequiredAdmin(AdminCompanies);
